import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.scss";

function SkeletonLoader() {
  return (
    <>
      <div className="carousel__item skeleton"></div>
      <div className="carousel__item skeleton"></div>
      <div className="carousel__item skeleton"></div>
      <div className="carousel__item skeleton"></div>
    </>
  );
}

export default function Carousel() {
  const [courses, setCourses] = useState([]);
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    fetch("/wp-json/draught/v1/learndash-courses")
      .then((response) => response.json())
      .then((data) => setCourses(data))
      .catch((error) => console.error("Error fetching courses:", error));
  }, []);

  const handleWindowScroll = (event) => {
    if (isScrolling) return;
    setIsScrolling(true);

    const scrollDirection = event.deltaY > 0 ? 1 : -1;
    const scrollAmount = scrollDirection * 100; // Adjust scroll speed multiplier as needed

    const carousel = document.querySelector(".slick-list");
    carousel.scrollTo({
      left: carousel.scrollLeft + scrollAmount,
      behavior: "smooth",
    });

    setTimeout(() => {
      setIsScrolling(false);
    }, 50);
  };

  useEffect(() => {
    window.addEventListener("wheel", handleWindowScroll, { passive: false });
    return () => window.removeEventListener("wheel", handleWindowScroll);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="carousel">
      {courses.length === 0 ? (
        <SkeletonLoader />
      ) : (
        <Slider {...settings}>
          {courses
            .filter((course) => course.image)
            .sort((a, b) => a.order - b.order)
            .map((course) => (
              <div className="carousel__item" key={course.id}>
                <img
                  src={course.image}
                  alt={course.title.rendered}
                  className="carousel__item__thumbnail"
                />
                <div className="px-4 pb-4">
                  <h3 className="carousel__item__title">{course.title.rendered}</h3>
                  <a
                    className="carousel__item__link elementor-button elementor-button-link elementor-size-sm card-button"
                    href={course.url}
                  >
                    <span className="elementor-button-content-wrapper">
                      <span className="elementor-button-text">Learn More &gt;</span>
                    </span>
                  </a>
                </div>
              </div>
            ))}
        </Slider>
      )}
    </div>
  );
}
